<template>
  <div class="login-body">
    <div class="login-main">
      <div class="main-logo">
        <img alt="" src="../assets/hm-logo.png" />
        <span>低代码开发平台</span>
      </div>
      <a-form
        :form="form"
        class="user-layout-login"
        ref="formLogin"
        id="formLogin"
        v-if="!isRegistered"
      >
        <a-tabs
          :activeKey="customActiveKey"
          :tabBarStyle="{ textAlign: 'center', borderBottom: 'unset' }"
          @change="handleTabClick"
        >
          <a-tab-pane key="tab1" tab="账号密码登录">
            <a-form-item>
              <a-input
                size="large"
                v-decorator="[
                  'username',
                  validatorRules.username,
                  { validator: this.handleUsernameOrEmail },
                ]"
                type="text"
                placeholder="请输入您的帐户名称"
              >
                <a-icon
                  slot="prefix"
                  type="user"
                  :style="{ color: 'rgba(0,0,0,.25)' }"
                />
              </a-input>
            </a-form-item>

            <a-form-item>
              <a-input
                v-decorator="['password', validatorRules.password]"
                size="large"
                type="password"
                autocomplete="false"
                placeholder="请输入您的密码"
              >
                <a-icon
                  slot="prefix"
                  type="lock"
                  :style="{ color: 'rgba(0,0,0,.25)' }"
                />
              </a-input>
            </a-form-item>
          </a-tab-pane>

          <a-tab-pane key="tab2" tab="手机号登录">
            <a-form-item>
              <a-input
                v-decorator="['mobile', validatorRules.mobile]"
                size="large"
                type="text"
                placeholder="请输入您的手机号"
              >
                <a-icon
                  slot="prefix"
                  type="mobile"
                  :style="{ color: 'rgba(0,0,0,.25)' }"
                />
              </a-input>
            </a-form-item>

            <a-row :gutter="16">
              <a-col class="gutter-row" :span="17">
                <a-form-item>
                  <a-input
                    v-decorator="['captcha', validatorRules.captcha]"
                    size="large"
                    type="text"
                    placeholder="请输入验证码"
                  >
                    <a-icon
                      slot="prefix"
                      type="mail"
                      :style="{ color: 'rgba(0,0,0,.25)' }"
                    />
                  </a-input>
                </a-form-item>
              </a-col>
              <a-col class="gutter-row" :span="7">
                <a-button
                  class="getCaptcha"
                  tabindex="-1"
                  :disabled="state.smsSendBtn"
                  @click.stop.prevent="getCaptcha(1)"
                  v-text="
                    (!state.smsSendBtn && '获取验证码') || state.time + ' s'
                  "
                ></a-button>
              </a-col>
            </a-row>
          </a-tab-pane>
        </a-tabs>

        <a-form-item>
          <a-checkbox v-model="formLogin.rememberMe">自动登陆</a-checkbox>
          <span class="forget-password" @click="forget">忘记密码</span>
        </a-form-item>

        <a-form-item style="margin-top: 24px">
          <a-button
            size="large"
            type="primary"
            htmlType="submit"
            class="login-button"
            @click.stop.prevent="handleSubmit"
            :disabled="loginBtn"
            >登录
          </a-button>
        </a-form-item>

        <a-form-item>
          <span class="login-method">其他登录方式</span>

          <a-icon
            class="login-method-item"
            @click="thirdLogin('wechat')"
            type="wechat"
          />
          <span class="forget-password" @click="register">注册账户</span>
        </a-form-item>
      </a-form>
      <a-form
        :form="registerForm"
        class="user-layout-login"
        ref="formLogin"
        id="formReister"
        v-if="isRegistered"
      >
        <div class="login-register-title">注册</div>

        <a-form-item>
          <a-input
            size="large"
            v-decorator="[
              'username',
              validatorRules.username,
              { validator: this.handleUsernameOrEmail },
            ]"
            type="text"
            placeholder="请输入您的账号"
          >
            <a-icon
              slot="prefix"
              type="user"
              :style="{ color: 'rgba(0,0,0,.25)' }"
            />
          </a-input>
        </a-form-item>

        <a-form-item
          ><a-input
            v-decorator="['password', validatorRules.password]"
            size="large"
            type="password"
            autocomplete="false"
            placeholder="6-16位密码， 区分大小写"
          >
            <a-icon
              slot="prefix"
              type="lock"
              :style="{ color: 'rgba(0,0,0,.25)' }"
            /> </a-input
        ></a-form-item>

        <a-form-item>
          <a-input
            v-decorator="['passwordConfirm', validatorRules.passwordConfirm]"
            size="large"
            type="password"
            autocomplete="false"
            placeholder="密码确认"
          >
            <a-icon
              slot="prefix"
              type="lock"
              :style="{ color: 'rgba(0,0,0,.25)' }"
            /> </a-input
        ></a-form-item>

        <a-form-item>
          <a-input
            v-decorator="['mobile', validatorRules.mobile]"
            size="large"
            type="text"
            placeholder="请输入您的手机号"
          >
            <a-icon
              slot="prefix"
              type="mobile"
              :style="{ color: 'rgba(0,0,0,.25)' }"
            />
          </a-input>
        </a-form-item>

        <a-row :gutter="16">
          <a-col class="gutter-row" :span="17">
            <a-form-item>
              <a-input
                v-decorator="['captcha', validatorRules.captcha]"
                size="large"
                type="text"
                placeholder="请输入验证码"
              >
                <a-icon
                  slot="prefix"
                  type="mail"
                  :style="{ color: 'rgba(0,0,0,.25)' }"
                />
              </a-input>
            </a-form-item>
          </a-col>
          <a-col class="gutter-row" :span="7" >
            <a-button
              size="small"
              class="getCaptcha"
              tabindex="-1"
              :disabled="state.smsSendBtn"
              @click.stop.prevent="getCaptcha(0)"
              v-text="(!state.smsSendBtn && '获取验证码') || state.time + ' s'"
            ></a-button>
          </a-col>
        </a-row>

        <a-form-item>
          <a-button
            size="large"
            type="primary"
            htmlType="submit"
            class="login-button register-button"
            :loading="loginBtn"
            @click.stop.prevent="registerAccount"
            :disabled="loginBtn"
            >注册
          </a-button>
          <span class="forget-password" @click="isRegistered = false"
            >使用已有账户登录</span
          >
        </a-form-item>
      </a-form>

      <a-modal v-model="wechatVisible" title="微信登录" :footer="null" forceRender>
        <div id="weixin" class="weixin" style="margin: 0 auto;width: 300px;">
          <iframe class="iframe"></iframe>
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
import loginApi from "@/request/api-manager/login.js"
import Vue from "vue";
import { TOKEN, USER_ID, USER_NAME } from "@/store/mutation-types";
export default {
  name: "login",
  data() {
    return {
      customActiveKey: "tab1",
      loginBtn: false,
      isRegistered: false,
      // login type: 0 email, 1 username, 2 telephone
      loginType: 0,
      requiredTwoStepCaptcha: false,
      stepCaptchaVisible: false,
      form: this.$form.createForm(this, { name: "login" }),
      registerForm: this.$form.createForm(this, { name: "register" }),
      encryptedString: {
        key: "",
        iv: "",
      },
      state: {
        time: 60,
        smsSendBtn: false,
      },
      formLogin: {
        username: "",
        password: "",
        captcha: "",
        mobile: "",
        rememberMe: true,
      },
      validatorRules: {
        username: {
          rules: [
            { required: true, message: "请输入用户名!"},
          ],
        },
        password: {
          rules: [
            { required: true, message: "请输入密码!" },
          ],
        },
        passwordConfirm:{
          rules: [
            { required: true, message: "请确认密码!" },
            {validator: this.validatePassword}
          ],
        },
        mobile: { rules: [{ validator: this.validateMobile }], },
        captcha: { rules: [{ required: true, message: "请输入验证码!" }] },
        inputCode: {
          rules: [
            { required: true, message: "请输入验证码!" },
            { validator: this.validateInputCode },
          ],
        },
      },
      verifiedCode: "",
      inputCodeContent: "",
      inputCodeNull: true,

      departList: [],
      departVisible: false,
      departSelected: "",
      currentUsername: "",
      validate_status: "",

      //第三方登录参数对象
      gitHubObj: {
        client_id: "",
        appId: "",
        redirect_uri: "",
        response_type: "",
      },
      giteeObj: {
        client_id: "",
        appId: "",
        redirect_uri: "",
        response_type: "",
      },
      wechatObj: {
        appid: "wx213112edd6f0633a",
        redirect_uri: "https://block-design.cn/login",
        state: "",
        style: "",
        href: "",
      },
      wechatVisible: false,
      code: this.$route.query.code
    };
  },
  mounted() {
    console.log(`code: ${this.code}`)
    if (this.code != undefined) {
      this.getWxUserInfo()
    }
  },
  methods: {
    login(params) {
      let that = this;
      that.$api.api_login
        .login(params)
        .then((res) => {
          if (res.message == "用户名或密码错误") {
            that.cmsFailed("用户名或密码错误");
          }
          //存储token
          Vue.ls.set(USER_NAME, res.result.userInfo.realname); // 存储用户名
          Vue.ls.set(TOKEN, res.result.token);
          Vue.ls.set(USER_ID, res.result.userInfo.id);
          that.$store.dispatch("changeUserName", res.result.userInfo.realname);
          that.$store.dispatch("changeToken", res.result.token);
          that.$store.dispatch("changeUserId", res.result.userInfo.id);
          //路由跳转默认首页
          that.$router.push({
            path: "/" + window.location.search,
          });
        })
        .catch((error) => {
          that.requestFailed(error);
        });
    },
    thirdLogin(type) {
      console.log(type);
      if (type == "github") {
        // window.location.href = "/githubAuthorize?client_id=e8066bfd81332a5fd345&redirect_uri=http://localhost:8080/signin_github";
      } else if (type == "gitee") {
        // window.location.href = "https://gitee.com/oauth/authorize?client_id={client_id}&redirect_uri={redirect_uri}&response_type=code";
      } else if (type === "wechat") {
        console.log(WxLogin)
        var obj = new WxLogin({
          self_redirect: false,
          id: "weixin",
          appid: this.wechatObj.appid,
          scope: "snsapi_login",
          redirect_uri: this.wechatObj.redirect_uri
        })
        this.wechatVisible = true
      }
    },
    getWxUserInfo() {
      let that = this;
      that.$api.api_login.wxLogin({ code: this.code }).then(res => {
        // console.log(res)
        if (!res.success) {
          that.cmsFailed(res.message)
          return
        }

        //存储token
        Vue.ls.set(USER_NAME, res.result.userInfo.realname); // 存储用户名
        Vue.ls.set(TOKEN, res.result.token);
        Vue.ls.set(USER_ID, res.result.userInfo.id);
        that.$store.dispatch("changeUserName", res.result.userInfo.realname);
        that.$store.dispatch("changeToken", res.result.token);
        that.$store.dispatch("changeUserId", res.result.userInfo.id);
        //路由跳转默认首页
        that.$router.push({
          path: "/",
        })
      }).catch((error) => {
        that.requestFailed(error);
      })
    },
    forget() {},
    register() {
      this.isRegistered = true;
    },
    registerAccount() {
      this.registerForm.validateFields((err, values) => {
        if (!err) {
          let custom = this.registerForm.getFieldsValue();
          let params = {
            mobile: custom.mobile,
            password: custom.password,
            smsCode: custom.captcha,
            username: custom.username
          }
          loginApi.register(params).then(res => {
            console.log(res,'resresres');
            if (!res.success) {
              this.$notification["error"]({
                message: "注册失败",
                description: res.message,
                duration: 4,
              });
            } else {
              this.$notification["success"]({
                message: "注册成功",
                duration: 4,
              });
              this.isRegistered = false
            }
          })
        }
      });
    },
    handleUsernameOrEmail(rule, value, callback) {
      const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/;
      if (regex.test(value)) {
        this.loginType = 0;
      } else {
        this.loginType = 1;
      }
      callback();
    },
    handleTabClick(key) {
      this.customActiveKey = key;
    },
    handleSubmit() {
      let that = this;
      let loginParams = {
        remember_me: that.formLogin.rememberMe,
      };
      that.loginBtn = true;
      // 使用账户密码登陆
      if (that.customActiveKey === "tab1") {
        that.form.validateFields(
          ["username", "password", "inputCode"],
          { force: true },
          (err, values) => {
            if (!err) {
              loginParams.username = values.username;
              loginParams.password = values.password;
              that.login(loginParams);
            } else {
              that.loginBtn = false;
            }
          }
        );
        // 使用手机号登陆
      } else {
        that.form.validateFields(
          ["mobile", "captcha"],
          { force: true },
          (err, values) => {
            if (!err) {
              loginParams.mobile = values.mobile;
              loginParams.captcha = values.captcha;
            }
          }
        );
      }
    },
    getCaptcha(code) {
      let that = this;
      let formName = code == 1 ? 'form' : 'registerForm'
      this[formName].validateFields(["mobile"], (err, values) => {
        if (!values.mobile) {
          that.cmsFailed("请输入手机号");
        } else if (!err) {
          this.state.smsSendBtn = true;
          let interval = window.setInterval(() => {
            if (that.state.time-- <= 0) {
              that.state.time = 60;
              that.state.smsSendBtn = false;
              window.clearInterval(interval);
            }
          }, 1000);
          let smsParams = {};
          smsParams.mobile = values.mobile;
          loginApi.getPhoneCode(smsParams).then(res => {
            if (!res.success) {
              this.$notification["error"]({
                message: "发送失败",
                description: res.message,
                duration: 4,
              });
            } else {
              this.$notification["success"]({
                message: "发送成功",
                duration: 4,
              });
            }
          })
        }
      });
    },
    cmsFailed(err) {
      this.$notification["error"]({
        message: "登录失败",
        description: err,
        duration: 4,
      });
      this.loginBtn = false;
    },
    requestFailed(err) {
      this.$notification["error"]({
        message: "登录失败",
        description:
          ((err.response || {}).data || {}).message ||
          err.message ||
          "接口请求出现错误，请稍后再试",
        duration: 4,
      });
      this.loginBtn = false;
    },
    validateMobile(rule, value, callback) {
      if (
        !value ||
        new RegExp(
          /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/
        ).test(value)
      ) {
        callback();
      } else {
        callback("您的手机号码格式不正确!");
      }
    },
    validateInputCode(rule, value, callback) {
      if (!value || this.verifiedCode == this.inputCodeContent) {
        callback();
      } else {
        callback("您输入的验证码不正确!");
      }
    },
    validatePassword(rule, value, callback){
      if (
        !value || value ==this.registerForm.getFieldsValue().password
      ) {
        callback();
      } else {
        callback("俩次输入的密码不一致!");
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.login-body {
  width: 100%;
  height: auto;
  background-color: #f5f5f5;

  .login-main {
    width: 490px;
    margin: 0 auto;
    margin-top: 100px;

    .main-logo {
      margin-bottom: 50px;

      img {
        width: 68px;
        vertical-align: middle;
      }

      span {
        font-size: 36px;
        color: #3c3c3c;
        margin-left: 30px;
        vertical-align: middle;
      }
    }

    .user-layout-login {
      label {
        font-size: 14px;
        float: left;
      }

      .login-method {
        font-size: 14px;
        float: left;
      }

      /deep/ .ant-input-affix-wrapper {
        margin-top: 7px;
        margin-bottom: 7px;
      }
      .input-item {
        height: 56px;
        width: 490px;
        box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06);
        border-radius: 4px;
        margin-top: 30px;
      }

      .login-method-item {
        font-size: 18px;
        margin: 0 15px;
      }

      .login-method-item:hover {
        color: #f44336;
      }

      .getCaptcha {
        display: block;
        width: 100%;
        height: 40px;
        margin-top: 7px;
      }

      .forget-password {
        color: #f7412d;
        font-size: 14px;
        float: right;
      }

      button.login-button {
        padding: 0 15px;
        font-size: 16px;
        height: 40px;
        width: 100%;
        background-color: #f7412d;
        border-color: #f7412d;
      }
      button.register-button {
        width: 234px;
        float: left;
      }

      .user-login-other {
        text-align: left;
        margin-top: 24px;
        line-height: 22px;

        .item-icon {
          font-size: 24px;
          color: rgba(0, 0, 0, 0.2);
          margin-left: 16px;
          vertical-align: middle;
          cursor: pointer;
          transition: color 0.3s;

          &:hover {
            color: #1890ff;
          }
        }

        .register {
          float: right;
        }
      }
    }
  }
}
.login-register-title {
  width: 100%;
  text-align: center;

  font-size: 22px;
  color: rgba(0, 0, 0, 0.85);
}

/deep/ .ant-tabs-nav .ant-tabs-tab-active {
  color: #f44336;
}

/deep/ .ant-tabs-ink-bar {
  background-color: #f44336;
  height: 3px;
}

/deep/ .ant-tabs-nav-container {
  line-height: 3;
}
</style>
